import lib from './lib';
import math from './math';
import standardTokens from './standard-tokens.json';

export default (
  data = [],
  context = {},
  statements = {},
  tokens = {},
  datum = {},
) => {
  // Initialize the scope
  const scope = lib(data, context, datum);
  const cache = {};
  const ctxTokens = Object.keys(context)
    .map((key) => [key, key.toUpperCase().replace(/\s/g, '')])
    .reduce(
      (acc, [key, KEY]) => ({
        ...acc,
        [`CTX_${KEY}`]: `context('${key}')`,
        [`CTX_${KEY}_LC`]: `lowercase($CTX_${KEY})`,
        [`CTX_${KEY}_CAP`]: `capitalize($CTX_${KEY})`,
      }),
      {},
    );

  const tokenSet = { ...standardTokens, ...ctxTokens, ...tokens };

  const evaluateStatement = (string) => {
    const searches = Object.keys(tokenSet)
      // Pair tokens with corresponding dollar-sign regex
      .map((key) => [key, new RegExp(`\\$${key}(?![A-Za-z0-9_])`, 'g')])
      // Only interpret the ones that are being used in this string
      .filter(([, search]) => search.test(string));

    // Add any values that haven't been evaluated yet to the cache
    searches.forEach(([key]) => {
      if (cache[key] === undefined) {
        try {
          cache[key] = (math.eval(tokenSet[key], scope) || '')
            .toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        } catch (e) {
          cache[key] = '';
          // eslint-disable-next-line no-console
          if (process.env.NODE_ENV === 'development') console.error(e);
        }
      }
    });

    // Replace corresponding tokens in statement with values from the cache
    return searches.reduce(
      (acc, [key, search]) => acc.replace(search, cache[key]),
      string,
    );
  };

  // Set references to all tokens/statements as simple es5 getters, accessed by
  // prefixing the token name with '$'
  Object.keys({ ...statements, ...tokenSet }).forEach((key) => {
    Object.defineProperty(scope, `$${key}`, {
      get: () => {
        if (cache[key] === undefined) {
          try {
            // If it's a token use math.eval.
            // If it's a statement use evaluateStatement.
            cache[key] = tokenSet[key]
              ? math.eval(tokenSet[key], scope)
              : evaluateStatement(statements[key]);
          } catch (e) {
            cache[key] = '';
            // eslint-disable-next-line no-console
            if (process.env.NODE_ENV === 'development') console.error(e);
          }
        }

        return cache[key];
      },
    });
  });

  return evaluateStatement;
};
